import { Close, Save } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, InputAdornment, Table, TableBody, TableCell, TableFooter, TableHead, TableRow } from '@mui/material'
import ArgonButton from 'components/ArgonButton'
import ArgonInput from 'components/ArgonInput'
import ArgonTypography from 'components/ArgonTypography'
import { postSubmit } from 'global/postFunc'
import React, { useEffect, useState } from 'react'

const InputAnggaranKas = ({ open, handleClose, updating, setUpdating, kd_pd, tahunAnggaran, addReq, decryptedUser, anggaranKas }) => {

    const listBulan = [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember'
    ];

    const [saving, setSaving] = useState(false)

    const [targetKeuangan, setTargetKeuangan] = useState({})
    const [targetFisik, setTargetFisik] = useState([])

    const [totalTargetKeuangan, setTotalTargetKeuangan] = useState(0)
    const [totalTargetFisik, setTotalTargetFisik] = useState(0)

    useEffect(() => {
        if (open) {
            console.log(anggaranKas);
            const tk = {}
            const tf = {}
            anggaranKas.forEach((anggaran) => {
                tk[anggaran.bulan] = anggaran.target_keuangan
                tf[anggaran.bulan] = anggaran.target_fisik
            })
            setTargetKeuangan(tk)
            setTargetFisik(tf)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    useEffect(() => {
        if (open) {
            let x = 0;
            let y = 0
            for (const property in targetKeuangan) {
                y = parseInt(targetKeuangan[property].replace(/[^0-9]/g, ""))
                x = x + y;
            }
            setTotalTargetKeuangan(x)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [targetKeuangan])
    
    useEffect(() => {
        if (open) {
            let x = 0;
            let y = 0
            for (const property in targetFisik) {
                y = parseFloat(targetFisik[property].replace(',', '.')) * 100
                console.log(y);
                x = x + y;
                console.log('x = ' + x);
            }
            setTotalTargetFisik(x)
            console.log(x);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [targetFisik])

    const submit = (e) => {
        e.preventDefault()
        addReq()
        setSaving(true)
        postSubmit(
            '/admin-opd/anggaran-kas/tambah',
            {
                ta: tahunAnggaran.ta,
                kd_pd: kd_pd,
                targetKeuangan: targetKeuangan,
                targetFisik: targetFisik
            },
            decryptedUser,
            (res) => {
                setSaving(false)
                handleClose()
                setUpdating(!updating)
            },
            (res) => {
                setSaving(false)
                // handleClose()
            }
        )
    }

    const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");
    const targetKeuanganChange = (value, index) => {
        let x = value.replace(/^0+/, "")
        setTargetKeuangan({ ...targetKeuangan, [index]: addCommas(removeNonNumeric(x)) })
    }

    return (
        <Dialog
            open={open}
            maxWidth="md"
            fullWidth
            scroll='paper'
            p={3}
            component='form'
            onSubmit={submit}
            sx={{
                minHeight: '80vh'
            }}
        >
            <DialogTitle>
                <ArgonTypography variant='body2' fontWeight="bold">Input Anggaran Kas</ArgonTypography>
            </DialogTitle>
            <DialogContent p={3}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow key={0}>
                            <TableCell sx={{ fontSize: 'small' }}>Bulan</TableCell>
                            <TableCell sx={{ fontSize: 'small' }}>
                                Target Realisasi Keuangan
                            </TableCell>
                            <TableCell sx={{ fontSize: 'small' }}>
                                Target Realisasi Fisik
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            listBulan.map((bulan, index) => (
                                <TableRow key={index} >
                                    <TableCell sx={{ fontSize: 'small' }}>{bulan}</TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>
                                        <ArgonInput
                                            required
                                            size="medium"
                                            type="text"
                                            onKeyDown={(e) => {
                                                if (e.key === "e" || e.key === "." || e.key === "+" || e.key === "-" || e.key === ",") {
                                                    return e.preventDefault()
                                                }
                                            }}
                                            value={targetKeuangan[index + 1] || ''}
                                            onChange={(e) => { targetKeuanganChange(e.target.value, index + 1) }}
                                            autoComplete='off'
                                            startAdornment={
                                                <InputAdornment position="start" >
                                                    <ArgonTypography fontSize='small'>Rp</ArgonTypography>
                                                </InputAdornment>
                                            }
                                        />
                                    </TableCell>
                                    <TableCell sx={{ fontSize: 'small' }}>
                                        <ArgonInput
                                            required
                                            size="medium"
                                            type="text"
                                            onKeyDown={(e) => {
                                                if (e.key === "e" || e.key === "+" || e.key === "-") {
                                                    return e.preventDefault()
                                                }
                                            }}
                                            value={targetFisik[index + 1] || ''}
                                            onChange={(e) => setTargetFisik({ ...targetFisik, [index + 1]: e.target.value })}
                                            autoComplete='off'
                                            endAdornment={
                                                <InputAdornment position="end" >
                                                    <ArgonTypography fontSize='small'>%</ArgonTypography>
                                                </InputAdornment>
                                            }
                                        />
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TableCell sx={{ fontSize: 'small' }}>Total</TableCell>
                            <TableCell sx={{ fontSize: 'small' }}>{
                                totalTargetKeuangan.toLocaleString?.('id-ID', {
                                    style: 'currency',
                                    currency: 'IDR',
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                })
                            }</TableCell>
                            <TableCell sx={{ fontSize: 'small' }}>{(totalTargetFisik/100).toFixed(2)}%</TableCell>
                        </TableRow>
                    </TableFooter>
                </Table>
            </DialogContent>
            <DialogActions>
                <Grid container spacing={2} justifyContent='flex-end' px={2} mb={2}>
                    <Grid item>
                        <ArgonButton color='info' variant='outlined' size="small" startIcon={<Close />} onClick={handleClose}>Batal</ArgonButton>
                    </Grid>
                    <Grid item>
                        <LoadingButton color='info' variant='contained' size="small" startIcon={<Save />} type='submit' loading={saving}>Simpan</LoadingButton>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default InputAnggaranKas